import { GET_HOOK_MAP_URL } from "~/constants";
import { BaseError, FetchError } from "~/errors";
import { Action, ServerActionResponse } from "~/types";
import { err, ok, Result } from "neverthrow";

export async function getHookMap(
  hookKey: string,
): Promise<Result<ServerActionResponse<Action[]>, BaseError>> {
  try {
    const response = await fetch(
      GET_HOOK_MAP_URL + "?" + new URLSearchParams({ hookKey }),
      {
        method: "GET",
      },
    );

    if (!response.ok) {
      throw new FetchError(`Request failed with status ${response.status}.`);
    }

    const responseJson = (await response.json()) as ServerActionResponse<
      Action[]
    >;

    if (!responseJson.ok) {
      return err(
        new BaseError(responseJson.errorType, responseJson.errorMessage),
      );
    }

    return ok(responseJson);
  } catch (error: unknown) {
    return error instanceof Error
      ? err(new FetchError(error.message))
      : err(new FetchError());
  }
}
